import React from 'react';
import { StudyGuidePie } from './study-guide-pie';
import moment from 'moment';
import { GuideNavWeek, GuideNavWeekDay, GuideNavWeekLink } from '@/components/custom/guide';

export function StudyGuideNavWeek({ studyGuide }) {
  const videosByDate = studyGuide['study-plan-videos'].reduce((acc, video) => {
    const formattedDate = moment(video.date).format('YYYY-MM-DD');
    if (!acc[formattedDate]) {
      acc[formattedDate] = [];
    }
    acc[formattedDate].push(video);
    return acc;
  }, {});

  const sortedDates = Object.keys(videosByDate).sort();

  const calculateCompletionPercentage = videos => {
    const total = videos.length;
    const completed = videos.filter(video => video.done).length;
    return total > 0 && completed > 0 ? (completed / total) * 100 : 0.1;
  };

  const days = sortedDates
    .filter(date => {
      const dayOfWeek = moment(date).day();
      return dayOfWeek >= 1 && dayOfWeek <= 5;
    })
    .map(date => {
      const dayName = moment(date).format('dddd');
      const completionPercentage = calculateCompletionPercentage(videosByDate[date]);

      return {
        name: dayName.slice(0, dayName.indexOf('-')),
        value: completionPercentage
      };
    });

  const currentDay = moment().format('dddd').split('-')[0];

  return (
    <GuideNavWeek>
      {days?.map(day => {
        const isActive = currentDay.toLowerCase() === day?.name.toLowerCase();
        const href = `#${day?.name.toLowerCase()}`;

        return (
          <GuideNavWeekDay key={day?.name}>
            <GuideNavWeekLink
              href={href}
              isActive={isActive}
            >
              <StudyGuidePie
                value={day?.value}
                text={day?.name.slice(0, 3)}
                size={44}
              />
            </GuideNavWeekLink>
          </GuideNavWeekDay>
        );
      })}
    </GuideNavWeek>
  );
}
